import { Checkbox, FormControlLabel } from "@material-ui/core";
import React from "react";
import { useTranslate } from "react-admin";

import { InfoBox } from "./InfoBox";
import { AllNoneButtons } from "./shared/AllNoneButtons";

interface LabelControlsProps {
  showAreaLabels: boolean;
  showRowLabels: boolean;
  showPortLabels: boolean;
  onToggleAreaLabels: () => void;
  onToggleRowLabels: () => void;
  onTogglePortLabels: () => void;
  onToggleAllLabels: () => void;
  onToggleNoneLabels: () => void;
}

export const LabelControls: React.FC<LabelControlsProps> = ({
  showAreaLabels,
  showRowLabels,
  showPortLabels,
  onToggleAreaLabels,
  onToggleRowLabels,
  onTogglePortLabels,
  onToggleAllLabels,
  onToggleNoneLabels,
}) => {

  const checkboxStyle = {
    padding: '7px',
  };

  const translate = useTranslate();
  return (
    <InfoBox title={translate('osfc.storage_ui.labels.title')} style={{ margin: "15px 0" }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={showAreaLabels}
              onChange={onToggleAreaLabels}
              name="showAreaLabels"
              color="secondary"
              size="small"
              style={checkboxStyle}
            />
          }
          label={translate('osfc.storage_ui.labels.show_area')}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={showRowLabels}
              onChange={onToggleRowLabels}
              name="showRowLabels"
              color="secondary"
              size="small"
              style={checkboxStyle}
            />
          }
          label={translate('osfc.storage_ui.labels.show_row')}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={showPortLabels}
              onChange={onTogglePortLabels}
              name="showPortLabels"
              color="secondary"
              size="small"
              style={checkboxStyle}
            />
          }
          label={translate('osfc.storage_ui.labels.show_port')}
        />
      </div>
      <AllNoneButtons onSelectAll={onToggleAllLabels} onClearAll={onToggleNoneLabels} />
    </InfoBox>
  );
};
